import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnimationsModule } from '@ibe.animations/animations.module';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { InputsModule } from '@ibe.components/common/inputs/inputs.module';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { MyDatePickerModule } from 'mydatepicker';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { BookAwardFlightsModuleModule } from '../book-award-flights/book-award-flights-module.module';
import { AdvanceSearchComponent } from './advance-search/advance-search.component';
// import { TAPAdvanceSearchComponent } from './advance-search/advance-search.tap.component';
import { AirportInputComponent } from './airport-input/airport-input.component';
// import { TAPAirportInputComponent } from './airport-input/airport-input.tap.component';
import { CheckinPnrLocatorComponent } from './checkin-pnr-locator/checkin-pnr-locator.component';
// import { TAPCheckinPnrLocatorComponent } from './checkin-pnr-locator/checkin-pnr-locator.tap.component';
import { INDRACheckinPnrLocatorComponent } from './checkin-pnr-locator/checkin-pnr-locator.indra.component';
import { FlightSearchComponent } from './flight-search/flight-search.component';
// import { TAPFlightSearchComponent } from './flight-search/flight-search.tap.component';
import { FlightStatusComponent } from './flight-status/flight-status.component';
// import { TAPFlightStatusComponent } from './flight-status/flight-status.tap.component';
// import { MiniIbeCheckInComponent } from './mini-ibe-check-in/mini-ibe-check-in.component';
// import { MiniIbeMyBookingsComponent } from './mini-ibe-my-bookings/mini-ibe-my-bookings.component';
import { SearchPageComponent } from './search-page/search-page.component';
// import { TAPSearchPageComponent } from './search-page/search-page.tap.component';
import { TripFinderComponent } from './trip-finder/trip-finder.component';
import { TAPTripFinderComponent } from './trip-finder/trip-finder.indra.component';
// import { MiniIbeComponent } from './mini-ibe/mini-ibe.component';

/* REPLICATED FILES */
import { INDRAFlightSearchComponent } from './flight-search/flight-search.indra.component';
import { INDRAAirportInputComponent } from './airport-input/airport-input.indra.component';
import { INDRASearchPageComponent } from './search-page/search-page.indra.component';
// import { TAPFlightStatusComponent } from './flight-status/flight-status.indra.component';
import { INDRAFlightStatusComponent } from './flight-status/flight-status.indra.component';
import { INDRAAdvanceSearchComponent } from './advance-search/advance-search.indra.component';
import { INDRAMiniIbeComponent } from './mini-ibe/mini-ibe.indra.component';
// import { MiniIbeMyBookingsComponent } from './mini-ibe-my-bookings/mini-ibe-my-bookings.indra.component';
import { INDRAMiniIbeMyBookingsComponent } from './mini-ibe-my-bookings/mini-ibe-my-bookings.indra.component';
import { MiniIbeCheckInComponent } from './mini-ibe-check-in/mini-ibe-check-in.indra.component';
import { TripFinderPageComponent } from './trip-finder-page/trip-finder-page.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NLFHeroModule } from '@ibe.components/shared/nlf-hero/nlf-hero.module';
import { NlfTabsModule } from '@ibe.components/common/nlf-tabs/nlf-tabs.module';
import { ButtonNavigationModule } from '@ibe.components/common/button-navigation/button-navigation/button-navigation.module';

@NgModule({
	imports: [
		CommonModule,
		TAPCommonModule,
		SharedModule,
		ReactiveFormsModule,
		FormsModule,
		MyDatePickerModule,
		DirectivesModule,
		BookAwardFlightsModuleModule,
		InputsModule,
		SVGModule,
		AnimationsModule,
		BsDatepickerModule.forRoot(),
		NLFHeroModule,
		NlfTabsModule,
		ButtonNavigationModule
	],
	declarations: [
		TripFinderComponent,
		TAPTripFinderComponent,
		FlightStatusComponent,
		// TAPFlightStatusComponent,
		INDRAFlightStatusComponent,
		FlightSearchComponent,
		// TAPFlightSearchComponent,
		INDRAFlightSearchComponent,
		SearchPageComponent,
		INDRASearchPageComponent,
		AirportInputComponent,
		INDRAAirportInputComponent,
		AdvanceSearchComponent,
		// TAPAdvanceSearchComponent,
		INDRAAdvanceSearchComponent,
		INDRAMiniIbeMyBookingsComponent,
		MiniIbeCheckInComponent,
		CheckinPnrLocatorComponent,
		INDRACheckinPnrLocatorComponent,
		INDRAMiniIbeComponent,
		TripFinderPageComponent
		// MiniIbeComponent
	],
	exports: [
		CommonModule,
		TAPCommonModule,
		SharedModule,
		ReactiveFormsModule,
		FormsModule,
		MyDatePickerModule,
		DirectivesModule,
		BookAwardFlightsModuleModule,
		InputsModule,
		SVGModule,
		AnimationsModule,
		TripFinderComponent,
		TAPTripFinderComponent,
		FlightStatusComponent,
		// TAPFlightStatusComponent,
		INDRAFlightStatusComponent,
		FlightSearchComponent,
		// TAPFlightSearchComponent,
		INDRAFlightSearchComponent,
		SearchPageComponent,
		INDRASearchPageComponent,
		AirportInputComponent,
		INDRAAirportInputComponent,
		AdvanceSearchComponent,
		// TAPAdvanceSearchComponent,
		INDRAAdvanceSearchComponent,
		INDRAMiniIbeMyBookingsComponent,
		MiniIbeCheckInComponent,
		CheckinPnrLocatorComponent,
		INDRACheckinPnrLocatorComponent,
		INDRAMiniIbeComponent
		// MiniIbeComponent
	]
})
export class SearchModule { }
